import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { OutgoKind } from 'types';

type Props = {
  open: boolean;
  onClose: () => void;
  onClickSubmit: (
    id: number,
    name: string,
    kind: OutgoKind,
    amount: number,
    registeredAt: number,
  ) => void;
  id: number | null;
  initialName: string;
  initialKind: OutgoKind;
  initialAmount: number;
  initialRegisteredAt: number;
};

const OutgoFormModal: React.FC<Props> = ({
  open,
  onClose,
  onClickSubmit,
  id,
  initialName,
  initialKind,
  initialAmount,
  initialRegisteredAt,
}) => {
  const [name, setName] = useState(initialName);
  const [kind, setKind] = useState<OutgoKind>(initialKind);
  const [amount, setAmount] = useState(initialAmount);

  useEffect(() => {
    setName(initialName);
    setKind(initialKind);
    setAmount(initialAmount);
  }, [initialName, initialKind, initialAmount]);

  const onSubmit = () => {
    onClickSubmit(id || 0, name, kind, amount, initialRegisteredAt);
    setName('');
    setKind('other');
    setAmount(0);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setName('');
        setKind('other');
        setAmount(0);
        onClose();
      }}
    >
      <DialogContent>
        <Stack spacing={3} maxWidth={400}>
          <TextField
            margin="normal"
            required
            label="名前"
            name="name"
            value={name}
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
          <Select
            label="種別"
            name="kind"
            value={kind}
            onChange={(event) => {
              setKind(event.target.value as OutgoKind);
            }}
            autoWidth
          >
            <MenuItem value="rent">家賃</MenuItem>
            <MenuItem value="food">食費</MenuItem>
            <MenuItem value="commodity">日用品</MenuItem>
            <MenuItem value="hobby">趣味</MenuItem>
            <MenuItem value="communication">通信</MenuItem>
            <MenuItem value="social">交際費</MenuItem>
            <MenuItem value="utility">光熱費</MenuItem>
            <MenuItem value="other">その他</MenuItem>
          </Select>
          <TextField
            margin="normal"
            required
            label="金額"
            type="number"
            name="amount"
            value={amount}
            onChange={(event) => {
              setAmount(parseInt(event.target.value, 10));
            }}
          />
        </Stack>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            sx={{ maxWidth: '64px' }}
            onClick={() => onSubmit()}
          >
            更新
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default OutgoFormModal;
